import soundWingFlap from '../assets/wing-flap.mp3'
import soundSuccess from '../assets/success.mp3'
import soundBump from '../assets/bump.mp3'
import soundSmallBump from '../assets/small-bump.mp3'

function loadSound(url) {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  let audioBuffer = null;

  // Load the sound asynchronously
  async function loadSoundAsync(url) {
    try {
      const response = await fetch(url);
      const buffer = await response.arrayBuffer();
      audioBuffer = await audioContext.decodeAudioData(buffer);
    } catch (error) {
      console.error('Error loading sound:', error);
    }
  }

  // Call loadSoundAsync immediately to load the sound
  loadSoundAsync(url);

  // Function to play the sound
  function play() {
    if (audioBuffer) {
      const source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(audioContext.destination);
      source.start(0);
    } else {
      console.error('Sound not loaded yet.');
    }
  }

  // Return an object with a play method
  return {
    play: function() {
      play();
    }
  };
}
  
// Need this or else sound play will error.
let interacted = false
const onInteract = () => {
    interacted = true

    document.body.removeEventListener( 'click', onInteract )
    document.body.removeEventListener( 'touchstart', onInteract )
    document.body.removeEventListener( 'keydown', onInteract )
}
document.body.addEventListener( 'click', onInteract )
document.body.addEventListener( 'touchstart', onInteract )
document.body.addEventListener( 'keydown', onInteract )

class Sounds {
    constructor() {
        this.sounds = {
            wingFlap: loadSound( soundWingFlap ),
            success: loadSound( soundSuccess ),
            bump: loadSound( soundBump ),
            smallBump: loadSound( soundSmallBump ),
        }
    }

    play ( name ) {
        if ( interacted ) {
            this.sounds[ name ].play()
        }
    }
}

export const sounds = new Sounds()